import React, { useState } from "react";
import "../styles/Feedback.css";
import { useMenu } from "../hooks/index.js";
import { baseBackendURL } from "../helpers/baseUrl.js";

const Feedback = () => {
  const { setOverlayContent } = useMenu();
  const [feedbackType, setFeedbackType] = useState("");
  const [includeLogs, setIncludeLogs] = useState(false);
  const [description, setDescription] = useState("");
  const [followUp, setFollowUp] = useState(false);
  const [responseEmail, setResponseEmail] = useState("");
  const [feedbackSuccess, setFeedbackSuccess] = useState(false);

  const feedbackTitles = {
    "Bug Report":
      "Describe the problem you've encountered. Provide as many details as you have time for to best help us solve the issue:",
    "Feature Request": "Describe the feature you are looking for:",
    Comment: "Message:",
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!feedbackType) {
      alert("Please select feedback type from the dropdown.");
      return;
    }

    const feedbackData = {
      feedbackType,
      includeLogs: feedbackType === "Bug Report" ? includeLogs : false,
      description,
      followUp: followUp ? responseEmail : null,
    };

    try {
      const response = await fetch(`${baseBackendURL}/submit_feedback`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify(feedbackData),
      });

      const result = await response.json();

      if (result.success) {
        setFeedbackSuccess(true);
        // Reset form fields
        setFeedbackType("");
        setIncludeLogs(false);
        setDescription("");
        setFollowUp(false);
        setResponseEmail("");
        setTimeout(() => {
          setOverlayContent(null);
        }, 1100);
      } else {
        console.error(
          "Feedback could not be submitted, please email app@prioritypop.com"
        );
      }
    } catch (error) {
      console.error("Error submitting feedback:", error);
    }
  };

  return feedbackSuccess ? (
    <h2 style={{ marginTop: "2rem" }}>Feedback sent!</h2>
  ) : (
    <>
      <h2>Submit Feedback</h2>
      <form onSubmit={handleSubmit} className="feedback-form">
        <label>
          Type of Feedback:
          <select
            value={feedbackType}
            onChange={(e) => setFeedbackType(e.target.value)}
          >
            <option value="" disabled>
              Select an option
            </option>
            <option value="Bug Report">Bug Report</option>
            <option value="Feature Request">Feature Request</option>
            <option value="Comment">Other Comments</option>
          </select>
        </label>

        {feedbackType === "Bug Report" && (
          <label className="checkbox-label">
            Include browser logs to help us troubleshoot?
            <input
              type="checkbox"
              checked={includeLogs}
              onChange={(e) => setIncludeLogs(e.target.checked)}
            />
          </label>
        )}

        <label>
          {feedbackTitles[feedbackType]}
          <textarea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            required
          />
        </label>

        {feedbackType === "Comment" && (
          <label className="checkbox-label">
            Would you like a follow-up to your submission?
            <input
              type="checkbox"
              checked={followUp}
              onChange={(e) => setFollowUp(e.target.checked)}
            />
          </label>
        )}

        {followUp && (
          <label>
            Your Email:
            <input
              type="email"
              value={responseEmail}
              onChange={(e) => setResponseEmail(e.target.value)}
              required
            />
          </label>
        )}

        <button type="submit">Send Feedback</button>
      </form>
    </>
  );
};

export default Feedback;
